const isCartDrawer = document
  .querySelector("#settingsCartDrawer")
  .innerText.trim()
  .split(",");

const isAvailableCartDrawer = isCartDrawer.includes(window.location.pathname);

class CartUpdateDrawer extends HTMLElement {
  constructor() {
    super();
    if (!isAvailableCartDrawer) {
      this.cartLayer = document.querySelector(".drawer__cart-section");
      this.overflow = document.querySelector("html");
      this.fetchRequest = false;
      if (document.querySelector(".cart-icon").href === "") {
        this.cartInteraction = this.cartInteraction.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.init();
      }
    }
    this.addEventListener('render', this.render.bind(this));
  }

  render(){
    this.cartUpsellInit();
    this.cartUpdate();
    this.openCartDrawer();
  }

  init() {
    const icon = document.querySelector(".cart-icon");
    if (icon && icon.href === "") {
      document.body.addEventListener("click", this.handleClickOutside);
      icon.addEventListener("click", this.cartInteraction);
    }
  }
  connectedCallback() {
    this.cartUpsellInit();
  }
  cartUpsellInit() {
    if (
      document
        .querySelector(
          ".drawer-product-recommendations-wrapper .swiper-wrapper"
        )
        ?.innerText?.trim() === ""
    ) {
      document
        .querySelector(".drawer-product-recommendations-wrapper")
        .remove();
      return;
    }
    document.querySelectorAll(".cart-upsell-wrapper")?.forEach((item) => {
      const slides = item.querySelectorAll(".swiper-slide");

      if (slides.length > 0) {
        Array.from(slides)
          .sort(({ dataset: { position: a } }, { dataset: { position: b } }) =>
            b.localeCompare(a)
          )
          .forEach((item) => item.parentNode.appendChild(item));

        new Swiper(".cart-recommendation", {
          loop: false,
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            300: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
            400: {
              slidesPerView: 1.3,
              spaceBetween: 30,
            },
          },
        });
      }
    });
  }
  disconnectedCallback() {
    const icon = document.querySelector(".cart-icon");
    if (icon && icon.href === "") {
      document.body.removeEventListener("click", this.handleClickOutside);
      icon.removeEventListener("click", this.cartInteraction);
    }
  }

  handleClickOutside(event) {
    const cartDrawer = document.getElementById("cart-drawer");
    const isOutside =
      !cartDrawer.contains(event.target) &&
      !event.target.classList.contains("cart-icon");
    const isCloseButton = event.target.classList.contains("close-cart-drawer");

    if (isOutside || isCloseButton) {
      this.closeCartDrawer();
    }
  }

  cartInteraction(event) {
    event.stopPropagation();
    this.openCartDrawer();

    if (!document.querySelectorAll(".quantity-input").length) {
      this.emptyCart();
    } else {
      this.cartUpdate();
    }
  }

  emptyCart() {
    const cartItems = document.querySelector(".cart-items")?.innerHTML;

    if (!cartItems) {
      fetch("/?sections=cart-drawer")
        .then((response) => response.json())
        .then((data) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(data["cart-drawer"], "text/html");
          document.querySelector(".cart-drawer-content").innerHTML =
            html.querySelector(".cart-drawer-content").innerHTML;
          this.cartUpsellInit();
        });
      const dataCartCount = document.querySelector("[data-cart-counter]");
      dataCartCount.classList.add("hidden");
      //dataCartCount.textContent = cartCount.value;
    } else {
      this.cartUpdate();
    }
  }

  openCartDrawer() {
    document.querySelector("#cart-drawer").classList.add("activeMenu");
    document.body.classList.add("activeMenu");
    this.cartLayer.classList.add("cart-drawer__overlay");
    this.overflow.style.overflow = "hidden";
  }

  closeCartDrawer() {
    document.querySelector("#cart-drawer").classList.remove("activeMenu");
    document.body.classList.remove("activeMenu");
    this.cartLayer.classList.remove("cart-drawer__overlay");
    this.overflow.style.overflow = "auto";
  }

  async discountUpdate({ token, discountCodes = [], discountCode }) {
    const storeFrontToken = "1d8154c1c8e47af0b1ba3640373ac0c5";
    const query = `
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart { discountCodes { code applicable } cost { checkoutChargeAmount { amount } subtotalAmount { amount } totalAmount { amount } } discountAllocations { discountedAmount { amount } } }
          userErrors { field message }
        }
      }`;
    const variables = { cartId: `gid://shopify/Cart/${token}`, discountCodes };

    try {
      const response = await fetch(
        `https://${window.Shopify.shop}/api/2025-04/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": storeFrontToken,
          },
          body: JSON.stringify({ query, variables }),
        }
      );
      const result = await response.json();

      if (
        result.errors ||
        result.data.cartDiscountCodesUpdate.userErrors.length
      ) {
        console.error(
          "Discount errors:",
          result.errors || result.data.cartDiscountCodesUpdate.userErrors
        );
        return {
          errors:
            result.errors || result.data.cartDiscountCodesUpdate.userErrors,
        };
      }
      return result;
    } catch (err) {
      console.error("Error in discountUpdate:", err);
      return { errors: true };
    }
  }

  cartUpdate() {
    const quantityInputs = document.querySelectorAll(".quantity-input");
    if (!quantityInputs.length) {
      this.emptyCart();
      return;
    }

    this.setupQuantityHandlers(quantityInputs);
    this.setupRemoveHandlers(quantityInputs);
    this.setupDiscountHandlers();
  }

  setupQuantityHandlers(quantityInputs) {
    document.querySelectorAll(".quantity-decrease").forEach((btn, i) => {
      btn.replaceWith(btn.cloneNode(true));
    });
    document.querySelectorAll(".quantity-increase").forEach((btn, i) => {
      btn.replaceWith(btn.cloneNode(true));
    });

    document.querySelectorAll(".quantity-decrease").forEach((btn, i) => {
      btn.addEventListener("click", () => {
        if (quantityInputs[i].value >= 0) {
          quantityInputs[i].value--;
          this.fetchRequest = true;
          quantityInputs[i].dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }
      });
    });

    document.querySelectorAll(".quantity-increase").forEach((btn, i) => {
      btn.addEventListener("click", () => {
        quantityInputs[i].value++;
        this.fetchRequest = true;
        quantityInputs[i].dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    quantityInputs.forEach((input) => {
      input.addEventListener("change", async () => {
        await this.updateCartItem(input);
      });
    });
  }

  async updateCartItem(input) {
    const productId = +input.getAttribute("cart-item-id");
    const quantity = input.value;
    const updates = { [productId]: +quantity };
    let isDiscountProduct = false;
    let isDiscountProductAvailable = window.discountGift.discountGiftEnabled;
    let discountMaxPrice = window.discountGift.discountMaxPrice;
    let discountCode = window.discountGift.discountCode;
    let isDiscountCodeAvailable = false;
    
    if (
      document
        .querySelector(".cart_discounts")
        ?.dataset?.discountCodes?.includes(discountCode) || document
        .querySelector(".cart-line-item__discount")
        ?.dataset?.discountCodes?.includes(discountCode)
    ) {
      isDiscountCodeAvailable = true;
    }

    let discountProductVariantId =
      window.discountGift.discountGiftProductVariantId;
    if (
      isDiscountProductAvailable &&
      discountProductVariantId &&
      discountCode &&
      discountMaxPrice
    ) {
      isDiscountProduct = !!document.querySelector(
        `#cart-items > li[data-id='${discountProductVariantId}']`
      );
    }

    const quantityInputs = document.querySelectorAll(".quantity-input");

    if (!this.fetchRequest) return;

    quantityInputs.forEach((inp) => {
      const form = inp.closest("form");
      if (form) {
        form.style.pointerEvents = "none";
        form.style.opacity = "0.5";
      }
    });
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error("Failed to update the cart.");

      const data = await response.json();
      let totalPrice = data.total_price / 100;

      if (totalPrice < discountMaxPrice) {
        if (isDiscountProduct) {
          const removeFreeGift = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-type": "application/json",
            },
            body: JSON.stringify({
              updates: {
                [`${discountProductVariantId}`]: 0,
              },
            }),
          });
          if (!removeFreeGift.ok) {
            throw new Error("Failed to remove the free gift.");
          }
        }
        if (isDiscountCodeAvailable) {
          await this.discountUpdate({
            token: data.token,
            discountCodes: [],
          });
        }
      }

      const cartDrawerResponse = await fetch(`/?sections=cart-drawer`);
      const cartDrawerData = await cartDrawerResponse.json();

      this.drawCart(cartDrawerData);
    } catch (err) {
      console.error("Update error:", err);
    } finally {
      // Re-enable all forms after update
      quantityInputs.forEach((inp) => {
        const form = inp.closest("form");
        if (form) {
          form.style.pointerEvents = "auto";
          form.style.opacity = "1";
        }
      });
      this.fetchRequest = false;
    }
  }

  setupRemoveHandlers(quantityInputs) {
    document.querySelectorAll(".remove-cart-item").forEach((btn, i) => {
      btn.replaceWith(btn.cloneNode(true));
    });

    document.querySelectorAll(".remove-cart-item").forEach((btn, i) => {
      btn.addEventListener("click", () => {
        quantityInputs[i].value = 0;
        this.fetchRequest = true;
        quantityInputs[i].dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  setupDiscountHandlers() {
    const discountHead = document.querySelector(".cart-discount-head button");
    const discountBlock = document.querySelector(".cart_discounts-block");
    const discountSubmit = document.querySelector(".cart-discount-submit");
    const discountInput = document.querySelector(".cart-discount-form input");
    const errorMsg = document.querySelector(".cart-discount-form p.error");

    discountHead?.addEventListener("click", () => {
      discountBlock.classList.toggle("active");
      discountHead.querySelector(".icon-plus").classList.toggle("active");
      discountHead.querySelector(".icon-minus").classList.toggle("active");
    });

    discountSubmit?.addEventListener("click", async (e) => {
      e.preventDefault();

      const discountCode = discountInput.value.trim();
      let discountMaxPrice = window.discountGift.discountMaxPrice;
      let discountGiftCode = window.discountGift.discountCode;
      let discountGiftId = window.discountGift.discountGiftProductVariantId;

      if (!discountCode) return;
      const discountCodes =
        document.querySelector(".cart_discounts").dataset.discountCodes !== ""
          ? document
              .querySelector(".cart_discounts")
              .dataset.discountCodes.split(",")
          : [];
      if (discountCodes.includes(discountCode)) return;
      discountCodes.push(discountCode);
      try {
        errorMsg.style.display = "none";
        errorMsg.textContent = "";
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();

        let totalPrice = cartData.total_price / 100;
        if (
          totalPrice < discountMaxPrice &&
          discountCode.toLowerCase() === discountGiftCode.toLowerCase()
        ) {
          errorMsg.style.display = "block";
          errorMsg.textContent = `Oops! This promotion requires a minimum order of $${discountMaxPrice}. Keep
        shopping to qualify for the promotion!`;
          setTimeout(() => {
            errorMsg.style.display = "none";
            errorMsg.textContent = "";
          }, 10000);
          return;
        }
        const result = await this.discountUpdate({
          token: cartData.token,
          discountCodes: [...discountCodes],
          discountCode,
        });
        const availableDiscountCode =
          result?.data?.cartDiscountCodesUpdate?.cart?.discountCodes.find(
            (i) => i.code === discountCode
          );

        if (!availableDiscountCode.applicable) {
          errorMsg.style.display = "block";
          errorMsg.textContent = "Enter a valid discount code";
          setTimeout(() => {
            errorMsg.style.display = "none";
            errorMsg.textContent = "";
          }, 10000);
        } else {
          if (discountCode.toLowerCase() === discountGiftCode.toLowerCase()) {
            let formData = {
              items: [
                {
                  id: discountGiftId,
                  quantity: 1,
                },
              ],
            };
            await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            });
          }
          const cartDrawerResponse = await fetch(`/?sections=cart-drawer`);
          const cartDrawerData = await cartDrawerResponse.json();
          this.drawCart(cartDrawerData);
        }
      } catch (err) {
        console.error("Discount apply error:", err);
      }
    });

    document.querySelectorAll(".remove-discount").forEach((btn) => {
      btn.addEventListener("click", async () => {
        let discountGiftCode = window.discountGift.discountCode;
        let discountGiftId = window.discountGift.discountGiftProductVariantId;
        const codeToRemove = btn.dataset.code;
        const discountCodes = (
          document.querySelector(".cart_discounts").dataset.discountCodes || ""
        ).split(",");
        const remainingCodes = discountCodes.filter(
          (code) => code !== codeToRemove
        );

        try {
          const cartResponse = await fetch("/cart.js");
          const cartData = await cartResponse.json();

          await this.discountUpdate({
            token: cartData.token,
            discountCodes: remainingCodes,
          });
          const getCookie = (name) => {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(";").shift();
          };
          if (getCookie("discount_code") !== "remove") {
            await fetch("/discount/remove");
          }

          if (codeToRemove.toLowerCase() === discountGiftCode.toLowerCase()) {
            let updates = {
              [discountGiftId]: 0,
            };
            await fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            });
          }
          const cartDrawerResponse = await fetch(`/?sections=cart-drawer`);
          const cartDrawerData = await cartDrawerResponse.json();

          this.drawCart(cartDrawerData);
        } catch (err) {
          console.error("Discount remove error:", err);
        }
      });
    });
  }

  drawCart(data) {
    const newDrawer = data["cart-drawer"];
    const parser = new DOMParser();
    const tempDiv = parser.parseFromString(newDrawer, "text/html");
    if (
      tempDiv
        .querySelector(
          ".cart-drawer-content .cart-recommendation .swiper-wrapper"
        )
        ?.innerText?.trim() === ""
    ) {
      tempDiv.querySelector(".drawer-product-recommendations-wrapper").remove();
    }
    const header = tempDiv.querySelector(".cart-drawer-header ");
    const content = tempDiv.querySelector(".cart-drawer-content");
    const cartCount = tempDiv.querySelector("#updateCartCount");
    const dataCartCount = document.querySelector("[data-cart-counter]");
    const cartDrawer = document.getElementById("cart-drawer");

    if (dataCartCount && cartCount) {
      if (dataCartCount.classList.contains("hidden")) {
        dataCartCount.classList.remove("hidden");
      }
      if (cartCount.value == 0) {
        dataCartCount.classList.add("hidden");
      }
      dataCartCount.textContent = cartCount?.value;
    }

    if (cartDrawer) {
      cartDrawer.innerHTML = "";
      if (header) cartDrawer.appendChild(header);
      if (content) cartDrawer.appendChild(content);
    }
    this.cartUpsellInit();
    this.cartUpdate();
  }
}

customElements.define("cart-update-drawer", CartUpdateDrawer);
